












import { defineComponent } from '@vue/composition-api';
import IntroPage from '@/app/layout/IntroPage.vue';
export default defineComponent({
    name: 'Platform',
    metaInfo: {
        title: 'Platform',
    },
    components: {
        IntroPage,
    },  
});
